var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cross",
    transform: "translate(-0.307 -0.307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_236968",
    "data-name": "Group 236968",
    transform: "translate(0.152 0.152)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11512",
    "data-name": "Rectangle 11512",
    width: 30,
    height: 30,
    rx: 15,
    transform: "translate(0.155 0.155)",
    fill: "rgba(76,42,113,0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_4",
    "data-name": "Union 4",
    d: "M11.813,4.437,7.16,8.553l4.653-4.115L7.16.322l4.653,4.115L16.465.322,11.813,4.437l4.653,4.115Z",
    transform: "translate(27.121 19.208) rotate(180)",
    fill: "none",
    stroke: "#4c2a71",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.87cfe36935285a1aa985b91640a12919.svg";
export { ForwardRef as ReactComponent };